import { ISubjectFieldsFragment } from '../apollo/graphqlSchema';

/**
 * When creating cohort, it's possible to get into situation when desired
 * subject key does not exist in configs subject list and user will see an
 * empty subject on cohort page.
 * This util will check subject list and return desired or default subject key
 */
export default (
  defaultSubjectKey: string,
  subjects: ISubjectFieldsFragment[],
  subjectKey?: string,
) => {
  // Using default subject key from config by default
  if (!subjectKey) {
    return defaultSubjectKey;
  }

  // Only in case if subject list includes desired subject key,
  // we will return it as a result
  if (subjects.some((subject) => subject.key === subjectKey)) {
    return subjectKey;
  }

  return defaultSubjectKey;
};
